module.exports = "/assets/data/578dba09b8717b218a90700af265d9c1-BH2.data.json";